module.exports = __webpack_public_path__ + "img/dice.fb365a86.svg";